import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQStructuredDataProps {
  faqItems: FAQItem[];
}

export const FAQStructuredData: React.FC<FAQStructuredDataProps> = ({ faqItems }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Remove any existing FAQ structured data
    const existingScript = document.querySelector('script[data-faq-structured-data="true"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Create FAQ structured data
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqItems.map(item => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answer
        }
      }))
    };

    // Add the structured data to the page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-faq-structured-data', 'true');
    script.textContent = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      const scriptToRemove = document.querySelector('script[data-faq-structured-data="true"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [faqItems, i18n.language]);

  return null;
};